import { render, staticRenderFns } from "./docgenIndex.vue?vue&type=template&id=2ab54b84&scoped=true"
import script from "./docgenIndex.vue?vue&type=script&lang=js"
export * from "./docgenIndex.vue?vue&type=script&lang=js"
import style0 from "./docgenIndex.vue?vue&type=style&index=0&id=2ab54b84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab54b84",
  null
  
)

export default component.exports